import { apiFetch } from './api';
import { AppSettings } from '../types';

const mapSettings = (data: AppSettings) => ({
  defaultInterval: data.defaultInterval,
  soundEnabled: data.soundEnabled,
  volume: data.volume,
  soundId: data.soundId,
  theme: data.theme,
  newsletterOptIn: data.newsletterOptIn ?? false,
});

export const getSettingsRemote = () =>
  apiFetch<AppSettings>(`/settings`).then(mapSettings);

export const updateSettingsRemote = (settings: AppSettings) =>
  apiFetch<AppSettings>(`/settings`, {
    method: 'PUT',
    body: JSON.stringify(settings),
  }).then(mapSettings);
